import React, { FC } from 'react';
import { ERoute } from 'common/const/route.enum';
import { ActivationPage, LoginPage, RegistrationPage, RestorePage } from 'app/pages';

interface IComponentProps {
  path: ERoute;
}

export const AuthLayout: FC<IComponentProps> = ({ path }) => {
  const renderCard = () => {
    switch (path) {
      case ERoute.Activation: {
        return <ActivationPage />;
      }
      case ERoute.RestorePassword: {
        return <RestorePage />;
      }
      case ERoute.Registration: {
        return <RegistrationPage />;
      }
      default: {
        return <LoginPage />;
      }
    }
  };

  return (
    <div className="redesign auth-layout">
      <div className="auth-layout__image" />

      {renderCard()}
    </div>
  );
};
